import styled from '@emotion/styled';

export const TotalEmployeeDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;
